"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeOfficeBootstrap = void 0;
const tslib_1 = require("tslib");
const mobx_1 = tslib_1.__importDefault(require("mobx"));
const theme_1 = require("./components/theme");
const services_1 = require("./services");
const page_state_1 = require("./state/page.state");
const store_1 = require("./store");
exports.IkeOfficeBootstrap = {
    initBasic($window) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            services_1.Services.Window.setWindow($window);
            $window.document.addEventListener('DOMContentLoaded', () => {
                (0, theme_1.attachSheet)();
                const waitForGoogleMaps = $window.setInterval(() => {
                    if (typeof google === 'undefined') {
                        return;
                    }
                    $window.clearTimeout(waitForGoogleMaps);
                    page_state_1.CurrentState.setGoogleMapsLoaded();
                }, 50);
            });
            yield services_1.Services.bindServices();
            services_1.Services.Route.bindRoutes();
            if (!services_1.Services.User.hasUser) {
                services_1.Services.Route.tokensLoaded = true;
                services_1.Services.Route.profilesLoaded = true;
                services_1.Services.Route.firstLoad();
            }
            $window['Ike'] = {
                AppStore: store_1.AppStore,
                Services: services_1.Services,
                State: page_state_1.CurrentState,
                mobx: mobx_1.default,
            };
        });
    },
    init($window) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        exports.IkeOfficeBootstrap.initBasic($window);
    },
};
//# sourceMappingURL=bootstrap.js.map